import { useContext } from 'react';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import ReactPlayer from 'react-player';

interface VideoItemProps {
  itemId: string;
  url: string;
}

const VideoItem: React.FC<VideoItemProps> = ({ url, itemId }) => {
  const visibility = useContext(VisibilityContext);
  const visible = visibility.useIsVisible(itemId, true);

  return (
    <div className={`transition duration-500 ${visible ? '' : 'opacity-50'}`}>
      <ReactPlayer
        config={{
          vimeo: {
            playerOptions: {
              maxwidth: '240px'
            }
          }
        }}
        height="100%"
        key={url}
        pip={false}
        playsinline={false}
        url={url}
        width="100%"
        controls
      />
    </div>
  );
};

export default VideoItem;
